import { useContext } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { GlobalContext } from "../Context";
import { useTranslation } from "react-i18next";
import { text } from "../../../theme/colours";

const CustomRangeSelection = ({ selection, setSelection, type }) => {
  const { t } = useTranslation("Stats");
  const { mobileView } = useContext(GlobalContext);

  const containerStyle = {
    width: mobileView ? "100%" : "12rem",
    mb: mobileView && "1rem",
    pr: !mobileView && "1%",
    pl: mobileView && "3%",
    borderRight: !mobileView && "solid 1px #eaeaea",
  };
  const titleStyle = {
    mb: "1rem",
    fontSize: "1rem",
    color: text.primary,
  };
  const buttonStyle = {
    justifyContent: "left",
    width: "100%",
    pl: "0",
    textTransform: "capitalize",
    fontWeight: 100,
    color: text.primary,
  };

  const handleRadio = (event) => {
    setSelection(event.target.value);
  };

  const handleButton = (selRange) => () => {
    setSelection(selRange);
  };

  return (
    <Box sx={containerStyle}>
      <Typography sx={titleStyle} variant="h3">
        {t("progressRange")}
      </Typography>
      {mobileView ? (
        <RadioGroup row value={selection} onChange={handleRadio}>
          <FormControlLabel
            value="week"
            control={<Radio />}
            label={t("Week")}
          />
          {type && (
            <FormControlLabel
              value="month"
              control={<Radio />}
              label={t("Month")}
            />
          )}
        </RadioGroup>
      ) : (
        <Box>
          <Button sx={buttonStyle} onClick={handleButton("week")}>
            {t("Week")}
          </Button>
          {type && (
            <Button sx={buttonStyle} onClick={handleButton("month")}>
              {t("Month")}
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

export default CustomRangeSelection;
